<template>
  <div class="buh-avr-manual-scan-modal">
    <p class="buh-avr-manual-scan-modal__hint">
      Укажите дату подписания на бумаге и загрузите PDF-скан.
      <strong>Важно:</strong> та же дата, что ушла в 1С/ЭСФ — не сегодняшняя, если на бумаге другая.
    </p>

    <div class="buh-avr-manual-scan-modal__date">
      <div class="buh-avr-manual-scan-modal__label">Дата подписания на бумаге *</div>
      <q-date
        v-model="signDate"
        mask="DD.MM.YYYY"
        :locale="dateLocaleRu"
        minimal
        class="buh-avr-manual-scan-modal__calendar"
      />
    </div>

    <DocumentUploader
      ref="documentUploader"
      label="PDF-скан подписанного АВР *"
      :allowed-extensions="['.pdf']"
      accepted-formats="PDF"
      @file-selected="onFileSelected"
      @file-removed="onFileRemoved"
    />

    <CustomModalFooter
      :btn-loading="loading"
      submit-btn-text="Загрузить"
      cancel-btn-text="Отмена"
      :disable-submit="!canSubmit"
      :on-submit="onSubmit"
      :onCancel="closeModal"
    />
  </div>
</template>

<script>
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import DocumentUploader from "@/components/common/DocumentUploader";
import { useAppStore } from "@/services/store/app";
import { dateLocaleRu } from "@/utils";
import { defaultBuhAvrManualSignDate } from "@/utils/buhAvrManualScan";

export default {
  name: "BuhAvrManualScanModal",
  components: { CustomModalFooter, DocumentUploader },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    const row = this.data?.row || {};
    return {
      loading: false,
      signDate: this.data?.defaultDate || defaultBuhAvrManualSignDate(row),
      selectedFile: null,
      dateLocaleRu,
    };
  },
  computed: {
    canSubmit() {
      return !!(this.signDate && this.selectedFile);
    },
  },
  methods: {
    onFileSelected(file) {
      this.selectedFile = file;
    },
    onFileRemoved() {
      this.selectedFile = null;
    },
    async onSubmit() {
      if (!this.canSubmit) return;
      this.loading = true;
      try {
        const onConfirm = this.data?.onConfirm;
        if (onConfirm) {
          await onConfirm({
            signDate: this.signDate,
            file: this.selectedFile,
          });
        }
        this.closeModal();
      } catch (e) {
        const msg = e?.response?.data?.message
          || e?.response?.data?.error
          || e?.message
          || "Не удалось загрузить скан";
        if (this.$refs.documentUploader?.setError) {
          this.$refs.documentUploader.setError(msg);
        }
        throw e;
      } finally {
        this.loading = false;
      }
    },
  },
  setup() {
    const appStore = useAppStore();
    const { closeModal } = appStore;
    return { closeModal };
  },
};
</script>

<style scoped lang="scss">
.buh-avr-manual-scan-modal {
  min-width: 360px;
  max-width: 520px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  &__hint {
    margin: 0;
    font-size: 14px;
    color: #374151;
    line-height: 1.45;
  }

  &__date {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &__label {
    font-size: 14px;
    font-weight: 500;
    color: #374151;
  }

  &__calendar {
    align-self: flex-start;
  }
}
</style>
